import { toast } from 'react-toastify';
import { apiV1 } from '../lib/axios';
import { useRegister } from '../hooks/useRegister';
import moment from 'moment';

export const CreateKey = async (keyType, transationalPassword, navigate) => {
  let response = await apiV1.post('/pixkey/store', {
    pixKeyType: keyType,
    transational_password: transationalPassword,
  });
  if (response.status === 200) {
    toast.info('Aguarde, sua nova chave será criada em breve!');
    return { isCreated: true };
  } else {
    toast.error('Erro ao criar uma nova chave!');
    return false;
  }
};
export const SendConfirmationCode = async (keyType, confirmationCode) => {
  const endpoint = "/pixkey/confirmationcode";

  try {
    await apiV1.post(endpoint, {
      pixKeyType: Number(keyType),
      confirmationCode: confirmationCode,
    });
  } catch (error) {
    throw error;
  }

}

export const ResendConfirmationCodeToUser = async (keyType) => {
  const endpoint = "/pixkey/resendconfirmationcodetouser";

  try {
    await apiV1.post(endpoint, {
      pixKeyType: keyType,
    });
  } catch (error) {
    throw error;
  }
}

export const deleteKey = async (id, navigate) => {
  let deleteResponse = await apiV1.delete(`/pixkey/delete/${id}`);
  if (deleteResponse.status === 200) {
    toast.success('Chave Deletada com Sucesso!');
    return true;
  } else {
    toast.error('Erro ao deletar a chave!');
    return false;
  }
};
export const claimKey = async (payload) => {
  let claimResponse = await apiV1.post(`/pixkey/claim`, payload);
  if (claimResponse.status === 200) {
    toast.success('Chave Reivindicada com Sucesso!');
    return true;
  }
  toast.error('Erro ao reivindicar a chave!');
  return false;
}

export const replyClaimKey = async (payload) => {
  let replyClaimResponse = await apiV1.post(`/pixkey/replyClaim`, payload);
  if (replyClaimResponse.status === 200) {
    toast.success(replyClaimResponse.data.message);
    return true;
  }
  toast.error('Erro ao reivindicar a chave!');
  return false;
}

export const cancelClaimKey = async (payload) => {
  let cancelClaimResponse = await apiV1.post(`/pixkey/cancelClaim`, payload);
  if (cancelClaimResponse.status === 200) {
    toast.success('reenvidicação cancelada com sucesso!');
    return true;
  }
  toast.error('Erro ao cancelar a reenvidicação!');
  return false;
}

export const pixSimulate = async (data) => {
  try {
    const response = await apiV1.post('/pix/installment/simulate', data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const payInstallmentPix = async (data) => {
  try {
    const response = await apiV1.post('/pix/installment/confirm', data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const listInstallmentPix = async () => {
  try {
    const response = await apiV1.get('/pix/installment/list');
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPixInfo = async (key, type) => {
  let payload = {
    key,
    keyType: type,
  };

  let infos = await apiV1.post('/pix/fitbank/getinfos', payload);
  return infos;
};

export const sendPixFitBank = async (data) => {
  return await apiV1.post("/pix/fitbank/transfer", data);
};

export const listPix = async () => {
  let infos = await apiV1.post('/pix/fitbank/list');
  return infos.data;
};

export const listContacts = async () => {
  try {
    let infos = await apiV1.get('/pixfavorite/list');
    return infos.data;
  } catch (err) {
    return {
      message: err.message
    }
  }
}

export const createQrcodePixFitBank = async (pixKey, value) => {
  let payload = {
    pixKey,
    value,
  };
  let infos = await apiV1.post('/pixqrcode/fitbank/create', payload);
  return infos.data;
};

export const getQrcodeInfoFitBank = async (hash) => {
  let payload = {
    hash,
  };
  let infos = await apiV1.post('/pixqrcode/fitbank/getinfo', payload);
  return infos.data;
};

export const getLimitsFitBank = async () => {
  let payload = {
    taxNumber: localStorage.getItem('taxNumber'),
  };
  let infos = await apiV1.get('/pix/fitbank/limits', payload);
  return infos.data.data;
};

export const setLimitsFitBank = async (values) => {
  let payload = {
    operationLimitRequests: values,
  };
  let infos = await apiV1.post('/pix/fitbank/limits', payload);
  return infos.data;
};


export const getLimitIncreaseRequests = async () => {
  const requests = await apiV1.get('/pix/limits/requests');
  return requests.data;
}

export const identificarTipoChavePix = (chave) => {
  const regexCNPJ = /^(\d{14}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/;
  const regexTelefone = /^(\+\d{2}(\d{2}|\d{3})\d{8,9}|\d{11,12})$/;
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (validaCpf(chave)) {
    return 1; // Chave PIX do tipo CPF
  } else if (regexCNPJ.test(chave)) {
    return 1; // Chave PIX do tipo CNPJ
  } else if (regexEmail.test(chave)) {
    return 2; // Chave PIX do tipo e-mail
  } else if (regexTelefone.test(chave)) {
    return 3; // Chave PIX do tipo telefone
  } else {
    return 4; // Chave PIX com formato desconhecido ou chave aleatória
  }
};

export const hideTaxNumber = (taxNumber) => {
  if (taxNumber) {
    let originalTaxNumber = taxNumber.toString();
    let formattedTaxNumber;
    if (originalTaxNumber.length === 14) {
      formattedTaxNumber = `** *** ${originalTaxNumber.slice(
        5,
        8
      )} /**** - ${originalTaxNumber.slice(-2)}`;
    } else {
      formattedTaxNumber = `*** *** ${originalTaxNumber.slice(
        6,
        9
      )} - ${originalTaxNumber.slice(-2)}`;
    }
    return formattedTaxNumber;
  }
};

export const validaCpf = (cpf) => {
  const cpfStr = cpf.replace(/[^\d]+/g, '');
  // Verifica se a variável cpf está em branco ou é igual a "undefined", exibindo uma msg de erro
  if (cpfStr === '' || cpfStr === undefined) {
    return false;
  }
  // Elimina CPFs invalidos conhecidos
  if (
    cpfStr.length !== 11 ||
    cpfStr === '00000000000' ||
    cpfStr === '11111111111' ||
    cpfStr === '22222222222' ||
    cpfStr === '33333333333' ||
    cpfStr === '44444444444' ||
    cpfStr === '55555555555' ||
    cpfStr === '66666666666' ||
    cpfStr === '77777777777' ||
    cpfStr === '88888888888' ||
    cpfStr === '99999999999'
  ) {
    return false;
  }

  // Valida 1o digito
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpfStr.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== parseInt(cpfStr.charAt(9))) {
    return false;
  }

  // Valida 2o digito
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpfStr.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== parseInt(cpfStr.charAt(10))) {
    return false;
  }
  return true;
};
